module.exports = __webpack_public_path__ + "img/emp4-3.aa7d68d9.jpg";